import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Loader2, Search } from "lucide-react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";

const TYPE_COLOR = {
  Buyer: "bg-indigo-100 text-indigo-700", Requirement: "bg-blue-100 text-blue-700", Lead: "bg-orange-100 text-orange-700",
  Deal: "bg-violet-100 text-violet-700", "Service Charge": "bg-emerald-100 text-emerald-700", Machine: "bg-slate-200 text-slate-700",
  Seller: "bg-cyan-100 text-cyan-700", Enquiry: "bg-amber-100 text-amber-700",
};

export default function AdminSearch() {
  const [params, setParams] = useSearchParams();
  const navigate = useNavigate();
  const [q, setQ] = useState(params.get("q") || "");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const query = params.get("q") || "";
    setQ(query);
    if (query.length < 2) { setResults([]); return; }
    setLoading(true);
    api.get("/admin/search", { params: { q: query } }).then((r) => setResults(r.data.results)).catch(() => {}).finally(() => setLoading(false));
  }, [params]);

  const submit = (e) => { e.preventDefault(); setParams({ q }); };

  return (
    <div>
      <h1 className="font-display text-2xl font-extrabold text-slate-900">Global Search</h1>
      <p className="mt-1 text-slate-500">Search buyers, requirements, leads, deals, machines, sellers, enquiries and IDs.</p>
      <form onSubmit={submit} className="relative mt-4 max-w-xl">
        <Search className="pointer-events-none absolute left-3 top-2.5 h-4 w-4 text-slate-400" />
        <Input data-testid="global-search-input" autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Type a name, mobile, or any ID (BUYER-, LEAD-, DEAL-, SC-, M-, E-)…" className="pl-9" />
      </form>

      {loading ? <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div> : (
        <div className="mt-5 space-y-2">
          {(params.get("q") || "").length >= 2 && results.length === 0 && <p className="py-10 text-center text-slate-500">No results for "{params.get("q")}".</p>}
          {results.map((r, i) => (
            <button key={i} data-testid={`search-result-${r.code}`} onClick={() => navigate(r.link)}
              className="flex w-full items-center gap-3 rounded-xl border border-slate-200 bg-white p-3 text-left hover:border-brand/40 hover:shadow-sm">
              <span className={`rounded-full px-2 py-0.5 text-[10px] font-bold ${TYPE_COLOR[r.type] || "bg-slate-100 text-slate-600"}`}>{r.type}</span>
              <div className="min-w-0">
                <p className="truncate font-semibold text-slate-900">{r.label || r.code} <span className="font-mono text-xs text-slate-400">{r.code}</span></p>
                {r.sub && <p className="truncate text-sm text-slate-500">{r.sub}</p>}
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
